//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faBookmark,
} from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'button-free-bookmarklet',
  data() {
    return {
      faBookmark,
      isDropdownOpen: false,
    };
  },
  computed: {
    pageUrl() {
      return this.$link(this.$route.path).url();
    },
  },
};
